<button (click)="goToPetition()">دادخواست</button>
